import type { JSX } from 'react';

import { TabList, Tabs } from '@change/ds-core-ui/next';

import { usePageTabs } from './hooks/usePageTabs';

export function PageTabs(): JSX.Element {
	const {
		data: { activeTab, items },
	} = usePageTabs();

	return (
		<Tabs selectedKey={activeTab} data-qa="tab-links">
			<TabList items={items} />
		</Tabs>
	);
}
